<template>
    <div>
      <b-row>
          <!-- <b-form> -->
            <div v-for="(section, sectionIndex) in forms" :key="sectionIndex" style="width: 100%">
              <transition name="fade">
                <div class="block--auth block--auth-large"
                v-if="isVisible(section)"
                :style="`margin-left:1%;width:${((section.span ? section.span : 12) / 12 * 100)-1}%; display: inline-block;`"
                >
                  <div  style="width: 100%">
                    <div class="block--auth-title">
                      <div style="max-width: 96%;">{{ section.title }}</div>
                        <a href="#" class="btn btn--small btn--simple clearer" style="color: white" :data-tagname="section.tagName">Clear</a>
                    </div>
                    <div class="group--form">
                      <template v-if="section.tagName === 'ED'">
                          <b-row>
                            <b-col :cols="field.span" v-for="(field, index) in section.fields"
                            :key="index" :span="field.span" v-bind="field" class="form__group" v-if="field.fieldType === 'NoticeComponent'">
                            <transition name="fade">
                              <RenderField :field="field" v-if="isVisible(field)" :overrideRequired="isRequired(field)">
                                <component
                                  :is="field.fieldType"
                                  :error="getError(field.tagname)"
                                  :value="getValue(field.tagname)"
                                  :currentField="field" class="form__field"
                                  style="margin:0!important"
                                ></component>
                              </RenderField>
                            </transition>
                            </b-col>
                          </b-row>
                          <b-row :key="`row-${sectionIndex}-${isinIndex}`" v-for="(isin, isinIndex) in isins">
                              <b-col :cols="12">
                                <template v-if="isin.label && isin.label.length">
                                  <h6 style="text-transform: uppercase;">{{ isin.label }}</h6>
                                </template>
                                <template v-else>
                                  <h6 style="text-transform: uppercase;">{{ isin.number }}</h6>
                                </template>
                                <p style="text-transform: uppercase;">{{ isin.descr }}</p>
                              </b-col>
                              <input type="hidden" :name="`formData[amounts][${isin.number}][ISIN]`" :value="isin.number">
                              <b-col :cols="field.span" v-for="(field, index) in section.fields" :key="index" :span="field.span" v-bind="field" class="form__group">
                                <!-- v-if="!(isinIndex > 0 && field.fieldType === 'NoticeComponent')" -->
                                <transition name="fade">
                                  <RenderField :field="field" v-if="field.fieldType !== 'NoticeComponent' && isVisible(field)" :overrideRequired="isRequired(field)">
                                    <component
                                      :is="field.fieldType"
                                      :currentField="field"
                                      :currency="isin.currency"
                                      :value="getNestedAmountValue(isin.number, field.tagname)"
                                      :error="getError('amounts.' + isin.number + '.' + field.tagname)"
                                      class="form__field"
                                      :storeInArray="`[amounts][${isin.number}]`"
                                    ></component>
                                  </RenderField>
                                </transition>
                              </b-col>
                          </b-row>
                      </template>
                      <b-row :key="`row-${sectionIndex}`" v-else>
                          <b-col  v-if="field.fieldType !== 'ModalComponent'" cols="12" :sm="field.span" v-for="(field, index) in section.fields" :key="index" :span="field.span" v-bind="field" class="form__group">
                            <transition name="fade">
                              <RenderField :field="field" v-if="isVisible(field)" :overrideRequired="isRequired(field)">
                                <component
                                  @updated="updated"
                                  :style="field.fieldType === 'NoticeComponent' ? 'margin:0!important' : ''"
                                  :is="field.fieldType"
                                  :overrideRequired="isRequired(field)"
                                  :error="getError(field.tagname)"
                                  :value="compute ? getValue(field.tagname) : null"
                                  :currentField="field" class="form__field"
                                ></component>
                              </RenderField>
                            </transition>
                          </b-col>
                          <template v-else>
                            <component
                              @updated="updated"
                              :is="field.fieldType"
                              :visible="isVisible(field)"
                              :inRenderMode="true"
                              :error="getError(field.tagname)"
                              :value="compute ? getValue(field.tagname) : null"
                              :currentField="field" class="form__field"
                            ></component>
                          </template>
                      </b-row>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          <!-- </b-form> -->

      </b-row>
      <div class="form-group text-center">
          <input type="checkbox" required> I have read and accept the <a href="/privacy-policy" target="_blank" >PRIVACY POLICY</a>
      </div>
      <div class="group--form has-no-margin-bottom" style="display: flex; justify-content: space-between;">
          <a v-if="cancelTo" class="btn btn--outline" :href="cancelTo" style="border: none;">Cancel</a>
          <template v-if="shouldButtonBectivated('FORM-SUBMIT-BUTTON')">
            <button class="btn submit-button" type="submit">Continue</button>
          </template>
          <template v-else>
            <button class="btn submit-button" type="submit" disabled="">Continue</button>
          </template>
      </div>
    </div>
</template>

<script>
import {
  FormBuilder
} from '@/components/bs/formbuilder'
import RenderField from './RenderField'

export default {
  name: 'Publish',
  store: ['forms', 'liveData'],
  props: ['standaloneForms', 'isins', 'formData', 'errors', 'formButtonDefinition', 'cancelTo'],
  components: {
    ...FormBuilder.$options.components,
    RenderField
  },
  mounted () {
    this.liveData = this.formData

    this.isins.forEach((isin) => {
      this.$store.liveData['amounts'] = this.$store.liveData['amounts'] ?? []
      this.$store.liveData['amounts'][isin.number] = this.$store.liveData['amounts'][isin.number]?? []
      this.$store.liveData['amounts'][isin.number]['ISIN'] = isin.number
    })


    if (this.standaloneForms) {
      this.forms = JSON.parse(this.standaloneForms)
    }

    this.registerClearers()

      setTimeout(() => {
          $('[data-toggle="tooltip"]').tooltip()
      }, 50)
  },

  data () {
    return {
      visibility: {},
      requirement: {},
      compute: true
    }
  },

  watch: {
    forms(value) {
      this.computeVisibility()
      // this.computeRequirement()
    },
    visibility(obj) {
      // this.registerClearers()
      // this.emptyHiddenFieldValuesFromFormData()
    }
  },

  methods: {
    updated(input) {
      this.$store.liveData[input.key] = input.value
      this.computeVisibility()
        $('[data-toggle="tooltip"]').tooltip()
    },

    isVisible(element) {
      var tag = element.tagName ?? element.tagname

      var identifier = `${tag}-${element.id}`

      return this.visibility[identifier]
    },

    shouldButtonBectivated(elementIdentifier) {
      return this.visibility[elementIdentifier]
    },

    isRequired(element) {
      var tag = element.tagname

      var identifier = `${tag}-${element.id}`
      return this.requirement[identifier]
    },

    emptyHiddenFieldValuesFromFormData () {
      Object.keys(this.visibility).filter(key => !this.visibility[key]).map(name => name.split("-")[0]).forEach(name => {
        if(this.formData[name]) {
          this.formData[name] = null
        }
      })
    },

    computeVisibility() {

      this.forms.forEach(section => {
            var sectionIdentifier = `${section.tagName}-${section.id}`
            this.visibility[sectionIdentifier] = this.elementVisibilty(section)

          return section.fields.forEach(field => {
            var fieldIdentifier = `${field.tagname}-${field.id}`
            this.visibility[fieldIdentifier] = this.visibility[sectionIdentifier] ? this.elementVisibilty(field) : false
          })
      })

      setTimeout(() => this.runAutonumeric(), 500)

      this.computeButtonVisibility()
      this.computeRequirement()
      this.registerClearers()
      // return this.visibility = map
    },

    computeButtonVisibility () {
        var fieldIdentifier = 'FORM-SUBMIT-BUTTON'
        this.visibility[fieldIdentifier] = this.elementVisibilty(JSON.parse(this.formButtonDefinition))
    },

    runAutonumeric(){
        const autoNumericOptionsEuro = {
        digitGroupSeparator        : ',',
        decimalCharacter           : '.',
        decimalCharacterAlternative: '.',
        decimalPlaces:'2',
        // currencySymbol             : '\u202f€',
        currencySymbolPlacement    : AutoNumeric.options.currencySymbolPlacement.suffix,
        roundingMethod             : AutoNumeric.options.roundingMethod.halfUpSymmetric,
        };

        $('.toThousands').each( function(element, index) {
          if (AutoNumeric.getAutoNumericElement($(this).get( 0 )) === null) {
              new AutoNumeric($(this).get( 0 ), autoNumericOptionsEuro);
          }
        });
    },

    computeRequirement() {
      var map = {}

      this.forms.forEach(section => {
          return section.fields.forEach(field => {
            var identifier = `${field.tagname}-${field.id}`
            map[identifier] = this.elementRequirement(field)
          })
      })

      return this.requirement = map
    },

    elementVisibilty(element) {
      var result = element.conditions.visibility.map(condition => {

        var actorIdentifier = `${condition.actor}-${condition.actorId}`
        var actorVisibility = this.visibility[actorIdentifier]

        if(condition.cond == "==") {
          return (this.liveData[condition.actor] == condition.value)  && actorVisibility
        }

        if(condition.cond == "!=") {
          return (this.liveData[condition.actor] != condition.value)  // && actorVisibility
        }

        if(condition.cond == "**") {
          return (this.liveData[condition.actor] != '' && this.liveData[condition.actor] != null)  && actorVisibility
        }

        if(condition.cond == "!!") {
          return (this.liveData[condition.actor] == '' || this.liveData[condition.actor] == null)  // && actorVisibility
        }

        if(condition.cond == "$$") {
          return this.liveData[condition.actor] == this.liveData[condition.value] && this.liveData[condition.actor] != ''  && this.liveData[condition.actor] != null
        }

        if(condition.cond == "@@") {
          return this.liveData[condition.actor] != this.liveData[condition.value]
        }

        return true
      })

      if(result.length) {
        if(element.conditions.visibility_operand === 'AND') {
          result = result.every(r => r)
        }

        if(element.conditions.visibility_operand === 'OR') {
          result = result.some(r => r)
        }
      } else {
        result = true
      }

      return result
    },

    elementRequirement(element) {
      if(!element.conditions.requirement) {
        return false;
      }

      var result = element.conditions.requirement.map(condition => {

        var actorIdentifier = `${condition.actor}-${condition.actorId}`
        var actorVisibility = this.visibility[actorIdentifier]

        if(condition.cond == "==") {
          return (this.liveData[condition.actor] == condition.value) // && actorVisibility
        }

        if(condition.cond == "!=") {
          return (this.liveData[condition.actor] != condition.value) // && actorVisibility
        }

        if(condition.cond == "**") {
          return (this.liveData[condition.actor] != '' && this.liveData[condition.actor] != null) // && actorVisibility
        }

        if(condition.cond == "!!") {
          return (this.liveData[condition.actor] == '' || this.liveData[condition.actor] == null) // && actorVisibility
        }

        if(condition.cond == "$$") {
          return this.liveData[condition.actor] == this.liveData[condition.value] && this.liveData[condition.actor] != '' && this.liveData[condition.actor] != null
        }

        if(condition.cond == "@@") {
          return this.liveData[condition.actor] != this.liveData[condition.value]  // && actorVisibility
        }

        return false
      })

      if(result.length) {
        if(element.conditions.visibility_operand === 'AND') {
          result = result.every(r => r)
        }

        if(element.conditions.visibility_operand === 'OR') {
          result = result.some(r => r)
        }
      } else {
        result = element.isRequired
      }

      return result
    },

    getError(identifier) {
      if(this.errors['formData.' + identifier]) {
        return this.errors['formData.' + identifier][0]
      }

      return null;
    },

    getValue (identifier) {
      if(Object.keys(this.formData).length) {
        return this.formData[identifier]
      }

      return ''
    },

    getNestedAmountValue (isin, identifier) {
      if(Object.keys(this.formData).length) {
        return this.formData['amounts'][isin][identifier]
      }

      return ''
    },

    registerClearers() {
      let _this = this
      setTimeout(() => {
        $('.clearer').on('click', function(event){
            event.preventDefault()
            $(this).parent().parent().children().find('input').each(function(){
                $(this).val('')
                $(this).prop("checked", false);
            })

            $(this).parent().parent().children().find('select').each(function(){
                $(this).val("");
            })

            var form = _this.forms.find(form => form.tagName === $(this).data('tagname'))

            if(form) {
              this.compute = false
              form.fields.forEach(field => {
                _this.$store.liveData[field.tagname] = null
                _this.formData[field.tagname] = null
              })
              this.compute = true
            }

            _this.computeVisibility()
        })
      }, 50)
    }
  }
}
</script>
<style  lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .8s ease-in-out;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
